import React, { useState } from 'react';
import { Burger, Drawer, Group, Box, Image } from '@mantine/core';
import { useMediaQuery } from '@mantine/hooks';
import { Link } from 'react-router-dom';

const Navbar: React.FC = () => {
	const [drawerOpened, setDrawerOpened] = useState(false);
	const isMobile = useMediaQuery('(max-width: 768px)');

	return (
		<Box
			style={{
				display: 'flex',
				justifyContent: 'space-between',
				alignItems: 'center',
				padding: '1rem',
				backgroundColor: '#f8f9fa',
				boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)',
			}}>
			{/* Logo */}
			<Box>
				<Link to="/">
					<Image
						src="/images/scorpioclassics.png"
						alt="Scorpio Classics"
						fit="cover"
					/>
				</Link>
			</Box>

			{/* Desktop or Mobile Menu */}
			{isMobile ? (
				<>
					<Burger
						opened={drawerOpened}
						onClick={() => setDrawerOpened(!drawerOpened)}
						size="sm"
						color="#212529"
					/>
					<Drawer
						opened={drawerOpened}
						onClose={() => setDrawerOpened(false)}
						size="80%"
						padding="md"
						overlayProps={{ opacity: 0.55, blur: 3 }}>
						<Group
							style={{
								gap: '10px',
								flexDirection: 'column',
								alignItems: 'center',
							}}>
							<Link
								to="/"
								onClick={() => setDrawerOpened(false)}>
								Home
							</Link>
							<Link
								to="/categories"
								onClick={() => setDrawerOpened(false)}>
								Products
							</Link>
							<Link
								to="/about-us"
								onClick={() => setDrawerOpened(false)}>
								About Us
							</Link>
							<Link
								to="/contact-us"
								onClick={() => setDrawerOpened(false)}>
								Contact
							</Link>
						</Group>
					</Drawer>
				</>
			) : (
				<Group style={{ gap: '30px', justifyContent: 'center', flexGrow: 1 }}>
					<Link
						to="/"
						style={{ textDecoration: 'none', color: '#212529' }}>
						Home
					</Link>
					<Link
						to="/categories"
						style={{ textDecoration: 'none', color: '#212529' }}>
						Products
					</Link>
					<Link
						to="/about-us"
						style={{ textDecoration: 'none', color: '#212529' }}>
						About Us
					</Link>
					<Link
						to="/contact-us"
						style={{ textDecoration: 'none', color: '#212529' }}>
						Contact
					</Link>
				</Group>
			)}
		</Box>
	);
};

export default Navbar;
